/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_No_LinkInputs */



/**
* | output |
* | --- |
* | "No online link" |
*
* @param {Meeting_Notes_No_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_no_link = /** @type {((inputs?: Meeting_Notes_No_LinkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_No_LinkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen online link")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de lien en ligne")
	return /** @type {LocalizedString} */ ("No online link")
});